import { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants, sortingOptions1 } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import { ConfigProvider, notification, Pagination, Button } from "antd";
import FoodItemComponent from "../component/FoodItemComponent";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import ViewFoodModal from "../component/modals/ViewFoodModal";
import FoodResetModal from "../component/modals/FoodResetModal";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import { useNavigate } from "react-router-dom";
import { FOOD_MENU } from "../constant/constants";
import DataNotFound from "../component/common/DataNotFound";
import { useSearchParams } from "react-router-dom";
import { getSearchParams, retrieveFoodList } from "../services/food-service";
import TableHeaderComponent from "../component/TableHeaderComponent";
import InventoryDependencyModal from "../component/inventory/InventoryDependencyModal";
import CustomLoader from "../component/menu/CustomLoader";

function Food() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paramValue =
    searchParams.get("menu") === "combo" ? FOOD_MENU.COMBO : FOOD_MENU.SINGLE;

  // eslint-disable-next-line no-unused-vars
  const { user, restaurantId, setNetworkCall, showNotification } = useUserStore();
  const [foods, setFoods] = useState(null);
  const [headerTitle, setHeaderTitle] = useState(paramValue);
  const [api, contextHolder] = notification.useNotification();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isStockUpdateModalOpen, setIsStockUpdateModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [searchText, setSearchText] = useState("");
  const [action, setAction] = useState("");
  const [total, setTotal] = useState(1);
  const [selectedItem, setSelectedItem] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [filter, setFilter] = useState({
    restaurantId: restaurantId,
    searchText: "",
    sortBy: "NEWEST",
    page: 1,
    perPage: 10,
  });
  const [changeStatusObj, setChangeStatusObj] = useState({
    recipeType: "",
    recipeId: "",
    optionId: "",
    status: "", // Active / Inactive
  });
  const [openStatusDependencyModal, setOpenStatusDependencyModal] = useState(false);
  const [dependencyObj, setDependencyObj] = useState({
    dependentFoods: [],
    dependentOrders: [],
    dependentOrders: [],
  });


  const onChangeMenuType = (value) => {
    setFilter({
      ...filter,
      page: 1,
      searchText: '',
      // sortBy: 'NEWEST'
    });
    setSearchText('')
    setHeaderTitle(value);
    getFoodList(value, 'FOOD_TYPE')
  };

  const onSelectFood = (val, action) => {
    const newStatus =
      action === constants.FOOD.ACTIVE ? "available" : "unavailable";
    const message = `Are you sure, want to mark <b>${val.name}</b> ${newStatus} ?`;

    // eslint-disable-next-line default-case
    switch (action) {
      case constants.FOOD.VIEW: {
        setSelectedItem(val);
        setIsViewModalOpen(true);
        break;
      }
      case constants.FOOD.ACTIVE:
      case constants.FOOD.INACTIVE: {
        setConfirmationMessage(message);
        setSelectedItem(val);
        setAction(action);
        setIsConfirmModalOpen(true);
        break;
      }
    }
  };

  const onClickEditButton = (record) => {
    headerTitle === FOOD_MENU.SINGLE
      ? navigate(`/food/edit/${record.name}/${record._id}`)
      : navigate(`/set-menu/edit/${record._id}`);
  };

  const onConfirm = (record, action) => {
    setIsConfirmModalOpen(false);
    orderStatusChange(
      record,
      action === constants.FOOD.ACTIVE
        ? constants.FOOD.ACTIVE
        : constants.FOOD.INACTIVE
    );
  };
  const onNotConfirm = () => {
    setIsConfirmModalOpen(false);
  };

  async function changeSingleFoodStatus(params) {
    const successMessage = params.status === 'Inactive' ? 'Food marked as unavailable successfully.' : 'Food marked as available successfully.';
    setNetworkCall(true);
    try {
      const res = await ApiService.INVENTORY_RECIPE_STATUS_CHANGE(params, user.token.token);
      if (!res || res.code !== 200) {
        setChangeStatusObj({});
        setNetworkCall(false);
        showNotification(res.data.message);
        return;
      }
      const { payload } = res;
      const { success, dependentFoods, dependentSetMenus, dependentOrders } = payload;

      // When success is false
      if (!success) {
        setNetworkCall(false);
        setOpenStatusDependencyModal(true);
        setDependencyObj({ dependentFoods, dependentSetMenus, dependentOrders });
        return;
      }
      setChangeStatusObj({});
      showNotification(successMessage, false);
      setNetworkCall(false);
      fetchFoodList();
      return;
    } catch (err) {
      setChangeStatusObj({});
      setNetworkCall(false);
      showNotification(err.response?.message);
      return;
    }
  }

  async function confirmChangeSingleFoodStatus(params) {
    setNetworkCall(true);
    try {
      const res = await ApiService.INVENTORY_RECIPE_STATUS_CHANGE_CONFIRM(params, user.token.token);
      if (!res || res.code !== 200) {
        setOpenStatusDependencyModal(false);
        setNetworkCall(false);
        showNotification(res.data.message);
        setChangeStatusObj({});
        return;
      }
      showNotification(res.message, false);
      setOpenStatusDependencyModal(false);
      setChangeStatusObj({});
      setNetworkCall(false);
      fetchFoodList();
      return;
    } catch (err) {
      setNetworkCall(false);
      setChangeStatusObj({});
      showNotification(err.response?.data?.message);
      return false;
    }
  }

  async function changeSetMenuFoodStatus(params) {
    const successMessage = params.status === 'Inactive' ? 'Combo food marked as unavailable successfully.' : 'Combo food marked as available successfully.';
    setNetworkCall(true);
    try {
      const res = await ApiService.PATCH_ADMIN_SET_MENUS_STATUS_CHANGE(params, user.token.token);
      if (res.code !== 200) {
        setNetworkCall(false);
        showNotification(res.data.message);
        return;
      }
      fetchSetMenuList();
      setNetworkCall(false);
      showNotification(successMessage, false);
    } catch (err) {
      showNotification(err.response.data.message);
    } finally {
      setNetworkCall(false);
    }
  }

  function onHandleConfirmChangeStatusForcefully() {
    if (
      dependencyObj.dependentOrders.length > 0 &&
      dependencyObj.dependentFoods.length < 1 &&
      dependencyObj.dependentSetMenus.length < 1
    ) {
      showNotification("Sorry We can not change the Single food status for order dependency.");
      setOpenStatusDependencyModal(false);
      setChangeStatusObj({});
      setDependencyObj({});
      return;
    }
    const params = {
      recipeType: changeStatusObj.recipeType,
      recipeId: changeStatusObj.recipeId,
      optionId: changeStatusObj.optionId || "",
      dependentFoods: [...dependencyObj.dependentFoods.map((item) => item.id)],
      dependentSetMenus: [...dependencyObj.dependentSetMenus.map((item) => item.id)],
      dependentOrders: [...dependencyObj.dependentOrders.map((item) => item.id)],
    };
    confirmChangeSingleFoodStatus(params);
  }

  const orderStatusChange = async (record, selection = "Inactive") => {
    const singleFoodParams = {
      recipeType: "FOOD",
      recipeId: record._id,
      optionId: "",
      status: selection
    }
    setChangeStatusObj({ ...singleFoodParams });
    const setMenuFoodParams = { setMenuId: record._id, status: selection };

    if (headerTitle === FOOD_MENU.SINGLE) {
      changeSingleFoodStatus(singleFoodParams);
      return;
    }

    changeSetMenuFoodStatus(setMenuFoodParams);
  };

  const onCloseViewModal = () => {
    setIsViewModalOpen(false);
  };

  const onPageChange = (page) => {
    setFilter({
      ...filter,
      page,
    });
    getFoodList(page, 'PAGE');
  };

  const onSearchText = (value) => {
    setFilter({
      ...filter,
      searchText: value,
    });

    getFoodList(value, 'SEARCH');
  };

  const onSortRecord = (value) => {
    setFilter({
      ...filter,
      sortBy: value,
    });

    getFoodList(value, 'SORT');
  };

  const getFoodList = async (changedValue, changeType) => {
    const params = getSearchParams(filter, changedValue, changeType);
    const menuType = changeType === 'FOOD_TYPE' ? changedValue : headerTitle;

    setNetworkCall(true);
    const result = await retrieveFoodList(
      menuType,
      params,
      user.token.token
    );

    setFoods(result.records);
    setTotal(result.total);
    setNetworkCall(false);
  };

  const fetchFoodList = () => {
    getFoodList('', 'RELOAD');
  };

  const fetchSetMenuList = async () => {
    getFoodList(FOOD_MENU.COMBO, "FOOD_TYPE");
  };

  const onClickUpdateStock = () => {
    fetchFoodList();
    setIsStockUpdateModalOpen(true); // Open the modal
  };

  const onModalFinish = async () => {
    // Close the modal
    setIsStockUpdateModalOpen(false);

    // Reset body scroll styles
    resetBodyScroll();

    fetchFoodList();
  };

  const onModalCancel = () => {
    setIsStockUpdateModalOpen(false); // Close the modal
    // Reset body scroll styles
    resetBodyScroll();
  };

  useEffect(() => {
    setFilter({
      ...filter,
      restaurantId,
      page: 1,
    });
    getFoodList(restaurantId, "INIT");
  }, [restaurantId]);

  function resetBodyScroll() {
    // Reset styles on html and body
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.documentElement.style.position = '';
    document.body.style.height = '';
    document.documentElement.style.height = '';
  }
  return (
    <div className="flex flex-col">
      {contextHolder}
      <CustomLoader />
      <Header title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} currentMenuKey={'T_3_S_3'} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="flex flex-row">
              <TableHeaderComponent
                record={{
                  title: "All Food",
                  headerTitle: headerTitle,
                  setHeaderTitle: onChangeMenuType,
                  hint: "Search in Food",
                  search: onSearchText,
                  isShowDropdownHeader: true,
                }}
                searchText={searchText}
                setSearchText={setSearchText}
                sortingOptions={sortingOptions1}
                onChangeSorting={onSortRecord}
                isDefaultSortByNeeded={true}
              />
              {headerTitle === FOOD_MENU.SINGLE ? (
                <Button
                  type="primary"
                  onClick={onClickUpdateStock}
                  className="mt-[16px] h-[40px] bg-[#FFD700] text-black border-none font-ubold text-[16px]"
                  style={{
                    backgroundColor: "#FFD700",
                    color: "black",
                    border: "none",
                    fontWeight: "bold",
                  }}
                >
                  Update Stock
                </Button>
              ) : (
                ""
              )}
            </div>
            <div className="flex flex-col min-h-[50vh]">
              {foods?.map((item, index) => (
                <div key={index}>
                  <FoodItemComponent
                    record={item}
                    callback={onSelectFood}
                    onEdit={onClickEditButton}
                    headerTitle={headerTitle}
                  />
                </div>
              ))}

              {foods?.length === 0 && <DataNotFound />}
            </div>
            <div className="flex flex-row justify-start font-uregular">
              <ConfigProvider
                theme={{
                  components: {
                    Pagination: {
                      itemActiveBg: "#FFD700",
                      fontFamily: "ubold",
                      colorPrimaryBorder: "#FFD700",
                      colorPrimary: "#111111",
                      colorPrimaryHover: "#111111",
                      itemInputBg: "#111111",
                      itemBg: "#E5E4E9",
                    },
                  },
                }}
              >
                <Pagination
                  total={total}
                  showTotal={(total) => `Total ${total} items`}
                  defaultPageSize={10}
                  defaultCurrent={filter.page}
                  current={filter.page}
                  onChange={onPageChange}
                  showSizeChanger={false}
                />
              </ConfigProvider>
            </div>
          </div>
          <FoodResetModal
            openModal={isStockUpdateModalOpen}
            records={{
              onFinish: onModalFinish,
              onCancel: onModalCancel,
              total: total,
            }}
          />

          <ConfirmationModal
            openModal={isConfirmModalOpen}
            records={{
              onFinish: onConfirm,
              onCancel: onNotConfirm,
              action: action,
              message: confirmationMessage,
              param: selectedItem,
            }}
          />
          <ViewFoodModal
            openModal={isViewModalOpen}
            records={{
              onFinish: onCloseViewModal,
              onCancel: onCloseViewModal,
              param: selectedItem,
            }}
          />

          {/* status change dependency model */}
          {(dependencyObj?.dependentFoods?.length > 0 ||
            dependencyObj?.dependentSetMenus?.length > 0 ||
            dependencyObj?.dependentOrders?.length > 0) && (
              <InventoryDependencyModal
                context="ITEM"
                open={openStatusDependencyModal}
                title="Are you sure want to change the single food status forcefully!"
                dependentFoods={dependencyObj.dependentFoods}
                dependentSetMenus={dependencyObj.dependentSetMenus}
                dependentOrders={dependencyObj.dependentOrders}
                handleConfirm={onHandleConfirmChangeStatusForcefully}
                handleCancel={() => setOpenStatusDependencyModal(false)}
              />
            )}
        </div>
      </div>
    </div>
  );
}

export default Food;
